import React from 'react';

import DeviceFormItems from './DeviceFormItems';
import DeviceItems from './DeviceItems';

const Services = ({ services }) => (
  services.map(service => (
    <div key={service.name} className="card-group mb12">
      <div className="card-group__item">
        <div className="card">
          <div className="card__content">
            <h3>{service.heading}</h3>
          </div>
        </div>
      </div>
      {service.returnable && (
        <DeviceFormItems devices={service.devices} />
      )}
      {!service.returnable && (
        <DeviceItems devices={service.devices} />
      )}
    </div>
  ))
);

export default Services;
